export enum CredentialFormat {
  MIFARE_EV2 = 18,
  MIFARE_CLASSIC = 17,
  UNIVERSAL = 255,
  BITS_26 = 0,
  MOBILE_CREDENTIAL = 20,
}

export enum ProfileType {
  SYSTEM = 'system',
  DEALER = 'dealer',
  ORGANIZATION = 'organization',
}

export enum RoleNames {
  // System User
  SUPERADMIN = 'Super Admin',
  CUSTOMER_SUPPORT = 'Customer Support',
  ADMINISTRATION = 'Administration',
  MARKETING = 'Marketing',

  // Dealer User
  DEALER_ADMINISTRATOR = 'Dealer Administrator',
  DEALER_ACCOUNTS_MANAGER = 'Dealer Accounts Manager',

  // Organization User
  ACCOUNT_ADMINISTRATOR = 'Account Administrator',
  ACCOUNT_SITE_MANAGER = 'Account Site Manager',
  ACCOUNT_DOOR_MANAGER = 'Account Door Manager',
}

export enum StripeSyncIssueStatus {
  RESOLVED = 'RESOLVED',
  UNRESOLVED = 'UNRESOLVED',
}

export enum DoorAccessMode {
  NORMAL = 0,
  PRIVACY = 1,
  APARTMENT = 2,
  CLASSROOM = 3,
  GLOBAL_ENTRY = 4,
  GLOBAL_EXIT = 5,
  ENTRY = 6,
  EXIT = 7,
}
